import { useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { routeList } from "../App";
import { lang } from "../assets/languages/en.language";
import DogNameCurved from "../components/DogNameCurved.component";
import { DogFaceIcon } from "../components/svgs/icons/DogFaceIcon.icon";
import { useUserStore } from "../store/useUserStore";
import { RootContainer } from "../styles/Container.style";
import { StandardImage } from "../styles/Image.style";
import { Title } from "../styles/Text";
import { Column, Gap } from "../styles/Utils";

export default function MatchHappeningPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const {
    profile: { isWarnedMatch },
  } = useUserStore();

  const handleSnootClick = () => {
    if (isWarnedMatch) navigate(routeList.chat);
    else navigate(routeList.warningMatch);
  };

  return (
    <RootContainer>
      <Column>
        <ImageContainer>
          <div>
            <DogNameCurved
              dogName={lang.matchHappeningPage.label1}
              color={theme.color.tertiary}
              textShadow={theme.font.elevation.big}
            />
          </div>
          <StandardImage src="/pictures/match-happening.jpg" />
          <div>
            <DogNameCurved
              dogName={lang.matchHappeningPage.label2}
              color={theme.color.tertiary}
              textShadow={theme.font.elevation.big}
            />
          </div>
        </ImageContainer>
        <DogFaceIconContainer onClick={handleSnootClick}>
          <DogFaceIcon color={theme.color.tertiaryLight} />
        </DogFaceIconContainer>
        <Gap $height={1} />
        <TitleOvl $color={theme.color.tertiaryLight}>{lang.matchHappeningPage.title}</TitleOvl>
      </Column>
    </RootContainer>
  );
}

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1.2;
  margin-top: 5%; // Important to not crop the tom of the curves dog name. Make the dogname text fit in the viewport.
  > img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  > div {
    position: absolute;
    width: 100%;
    z-index: 2;
  }
  div:first-of-type {
    top: 0%;
  }
  div:last-of-type {
    bottom: 0%;
  }
`;

const TitleOvl = styled(Title)`
  font-size: ${(props) => props.theme.font.size.title.xbig};
`;

const DogFaceIconContainer = styled.div`
  z-index: 99; // button click access blocked by svg curve above
  height: 10rem;
  padding: 0.5rem;
  border: 4px solid ${(props) => props.theme.color.tertiaryLight};
  border-radius: 100px;
  margin: auto;
  > svg {
    height: 100%;
  }
`;
